import { render, staticRenderFns } from "./VehicleGrainMonitoring.vue?vue&type=template&id=22679672&scoped=true"
import script from "./VehicleGrainMonitoring.vue?vue&type=script&lang=js"
export * from "./VehicleGrainMonitoring.vue?vue&type=script&lang=js"
import style0 from "./VehicleGrainMonitoring.vue?vue&type=style&index=0&id=22679672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22679672",
  null
  
)

export default component.exports